var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmojiRelievedFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC4D",
    d: "M36 18c0 9.941-8.059 18-18 18S0 27.941 0 18S8.059 0 18 0s18 8.059 18 18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#664500",
    d: "M28.312 15.612a.503.503 0 0 0-.61-.014c-.012.009-1.261.902-3.702.902c-2.44 0-3.69-.893-3.7-.9a.5.5 0 0 0-.757.603c.06.135 1.5 3.297 4.457 3.297c2.958 0 4.397-3.162 4.457-3.297a.498.498 0 0 0-.145-.591zm-12.61-.014c-.012.009-1.26.902-3.702.902c-2.441 0-3.69-.893-3.7-.9a.5.5 0 0 0-.757.603c.06.135 1.5 3.297 4.457 3.297c2.958 0 4.397-3.162 4.457-3.297a.501.501 0 0 0-.755-.605zM29.001 13a.998.998 0 0 1-.801-.4c-2.592-3.456-6.961-2.628-7.004-2.62a.998.998 0 0 1-1.177-.784a1.001 1.001 0 0 1 .784-1.177c.231-.047 5.657-1.072 8.996 3.38A1 1 0 0 1 29.001 13zM6.999 13a1 1 0 0 1-.799-1.6c3.339-4.454 8.766-3.426 8.996-3.38a1.001 1.001 0 0 1-.39 1.962C14.62 9.947 10.37 9.174 7.8 12.6a.998.998 0 0 1-.801.4zm16.255 10.577a.513.513 0 0 0-.597.06c-.01.008-1.013.863-4.657.863c-3.641 0-4.646-.854-4.646-.854a.5.5 0 0 0-.838.475c.01.044 1.144 4.379 5.484 4.379s5.474-4.335 5.485-4.379a.497.497 0 0 0-.231-.544z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiRelievedFace);
export default __webpack_public_path__ + "static/media/emoji-relieved-face.f92c0212e797e8671757c748dd40300c.svg";
export { ForwardRef as ReactComponent };